import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
/**
 * Higher Order Component taking in a concrete PollsPane component and
 * augmenting it with state/behavior common to both web and native implementations.
 *
 * @param {React.AbstractComponent} Component - The concrete component.
 * @returns {React.AbstractComponent}
 */
const abstractPollsPane = (Component) => (extraProps) => {
    const [createMode, setCreateMode] = useState(false);
    const onCreate = () => {
        setCreateMode(true);
    };
    const { t } = useTranslation();
    return (React.createElement(Component, Object.assign({ createMode: createMode, onCreate: onCreate, setCreateMode: setCreateMode, t: t }, extraProps)));
};
export default abstractPollsPane;
